import { render } from "./Popper.vue?vue&type=template&id=946c7940&scoped=true&ts=true"
import script from "./Popper.vue?vue&type=script&lang=ts"
export * from "./Popper.vue?vue&type=script&lang=ts"

import "./Popper.vue?vue&type=style&index=0&id=946c7940&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946c7940"]])

export default __exports__